// ES Module shim for fastdom to ensure proper default export
// The original fastdom uses UMD which can cause interop issues with rspack

// Use dynamic import path to avoid alias recursion
// eslint-disable-next-line @typescript-eslint/no-var-requires
const fastdomInstance = require('fastdom/fastdom.js')

// Create a proper ES module export
export default fastdomInstance
export const measure = fastdomInstance.measure.bind(fastdomInstance)
export const mutate = fastdomInstance.mutate.bind(fastdomInstance)
export const clear = fastdomInstance.clear.bind(fastdomInstance)
export const extend = fastdomInstance.extend.bind(fastdomInstance)
